import columns from '../../../../../react-table/helpers/columns';
import { sumTotal, sumRoundedTotal } from '../../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    FloatColumn,
    NumberColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);

  const countAndWeightColumns = receptacleType => [
    new NumberColumn(
      'Count',
      `${receptacleType}.receptacleCount`,
    ).withTotalHeader(sumTotal),
    new FloatColumn(
      'Net',
      `${receptacleType}.totalNetWeight`,
    ).withTotalHeader(sumRoundedTotal),
    new FloatColumn(
      'Gross',
      `${receptacleType}.totalGrossWeight`,
    ).withTotalHeader(sumRoundedTotal),
  ];

  return [
    {
      Header: '',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn(
          'Despatch ID',
          'predesWithDespatchS8IdAndLastTransportLeg.despatchS8Id',
        ).withWidth(210).withTotalHeader('Total')),
      ],
    },
    {
      Header: 'Last Leg',
      columns: [
        new TextColumn(
          'Conveyance reference',
          'predesWithDespatchS8IdAndLastTransportLeg.lastTransportLeg.name',
        ).withWidth(155),
        new DateTimeColumn(
          'Planned arrival date',
          'predesWithDespatchS8IdAndLastTransportLeg.lastTransportLeg.scheduledLocalDateTime',
        ).withWidth(145),
      ],
    },
    {
      Header: 'Bag (BG)',
      columns: countAndWeightColumns('despatchParticularReceptacleTypeSummary.bag'),
    },
    {
      Header: 'IPC bags (IS)',
      columns: countAndWeightColumns('despatchParticularReceptacleTypeSummary.ipcBag'),
    },
    {
      Header: 'Domestic flat tray (GU)',
      columns: countAndWeightColumns('despatchParticularReceptacleTypeSummary.domesticFlatTray'),
    },
    {
      Header: 'Tray (PU)',
      columns: countAndWeightColumns('despatchParticularReceptacleTypeSummary.tray'),
    },
    {
      Header: 'IPC tray (IL)',
      columns: countAndWeightColumns('despatchParticularReceptacleTypeSummary.ipcTray'),
    },
    {
      Header: 'Container (CN)',
      columns: countAndWeightColumns('despatchParticularReceptacleTypeSummary.container'),
    },
    {
      Header: 'IPC pallet box (IB)',
      columns: countAndWeightColumns('despatchParticularReceptacleTypeSummary.ipcPalletBox'),
    },
    {
      Header: 'Other (BE, CG, FW, NE, PB, PC, PX)',
      columns: countAndWeightColumns('despatchParticularOtherReceptacleTypeSummary.other'),
    },
    {
      Header: 'Totals',
      columns: countAndWeightColumns('despatchParticularTotalReceptacleTypeSummary.total'),
    },
  ];
};
